import {useEffect, useState} from "react";
import {getDisplayedCabinetStyleNavItems} from "../helpers/cabinetStyleNavigationHelper";

const useCabinetStyleNavItems = ({partIds, featuresData, isLoading}) => {
  const [displayedNavItemsByPartId, setDisplayedNavItemsByPartId] = useState({});
  const [isPreparingNavItems, setIsPreparingNavItems] = useState(true);

  useEffect(() => {
    if (isLoading) {
      setIsPreparingNavItems(true);
      return;
    }

    // Keep the existing sidebar loader painted before cabinet-style matching runs.
    const preparationTimer = setTimeout(() => {
      const preparedNavItems = partIds.reduce((navItemsByPartId, partId) => {
        navItemsByPartId[partId] = getDisplayedCabinetStyleNavItems(partId, featuresData[partId]);
        return navItemsByPartId;
      }, {});

      setDisplayedNavItemsByPartId(preparedNavItems);
      setIsPreparingNavItems(false);
    }, 0);

    return () => {
      clearTimeout(preparationTimer);
    };
  }, [featuresData, isLoading, partIds]);

  return {
    displayedNavItemsByPartId,
    isPreparingNavItems,
  };
};

export default useCabinetStyleNavItems;
